if (!customElements.get('size-guide-modal')) {
  customElements.define(
    'size-guide-modal',
    class SizeGuideModal extends DrawerComponent {
      constructor() {
        super();
      }

      prepareToShow() {
        super.prepareToShow();
        document.dispatchEvent(new CustomEvent('size-guide:open'));
      }

      handleAfterHide() {
        super.handleAfterHide();
        document.dispatchEvent(new CustomEvent('size-guide:close'));
      }
    }
  );
}

// Size guide button handler
class SizeGuideButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.modalId = this.dataset.modalId || 'SizeGuideModal';
    
    if (this.button) {
      this.button.addEventListener('click', this.openSizeGuide.bind(this));
    }
  }

  openSizeGuide(e) {
    e.preventDefault();
    const modal = document.getElementById(this.modalId);
    if (modal) {
      modal.show();
    }
  }
}

customElements.define('size-guide-button', SizeGuideButton);
